(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) :
  (global = global || self, factory(global.TypeMe = {}, global.React));
}(this, function (exports, React) { 'use strict';

  var React__default = 'default' in React ? React['default'] : React;

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArrayLimit(arr, i) {
    if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
      return;
    }

    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  var FORWARD = 1;
  var BACKSPACE = -1;
  var LINEBREAK = 2;
  var PAUSE = 3;
  var END = 0;

  var TypeMe = function TypeMe(_ref) {
    var loop = _ref.loop,
        strings = _ref.strings,
        children = _ref.children,
        className = _ref.className,
        hideCursor = _ref.hideCursor,
        typingSpeed = _ref.typingSpeed,
        deleteSpeed = _ref.deleteSpeed,
        backspaceDelay = _ref.backspaceDelay,
        startAnimation = _ref.startAnimation,
        onAnimationEnd = _ref.onAnimationEnd,
        cursorCharacter = _ref.cursorCharacter,
        cursorBlinkSpeed = _ref.cursorBlinkSpeed;

    var _useState = React.useState(function () {
      return Math.random().toString(36).substring(2, 5) + Math.random().toString(36).substring(2, 5);
    }),
        _useState2 = _slicedToArray(_useState, 1),
        instanceId = _useState2[0];

    var _useState3 = React.useState(0),
        _useState4 = _slicedToArray(_useState3, 2),
        deleteChar = _useState4[0],
        setDeleteChar = _useState4[1];

    var _useState5 = React.useState(0),
        _useState6 = _slicedToArray(_useState5, 2),
        itemIndex = _useState6[0],
        setItemIndex = _useState6[1];

    var _useState7 = React.useState(0),
        _useState8 = _slicedToArray(_useState7, 2),
        charIndex = _useState8[0],
        setCharIndex = _useState8[1];

    var _useState9 = React.useState(false),
        _useState10 = _slicedToArray(_useState9, 2),
        animationPaused = _useState10[0],
        setAnimationPaused = _useState10[1];

    var _useState11 = React.useState(false),
        _useState12 = _slicedToArray(_useState11, 2),
        animationEnded = _useState12[0],
        setAnimationEnded = _useState12[1];

    var _useState13 = React.useState(''),
        _useState14 = _slicedToArray(_useState13, 2),
        typedString = _useState14[0],
        setTypedString = _useState14[1];

    var _useState15 = React.useState(''),
        _useState16 = _slicedToArray(_useState15, 2),
        newTypedString = _useState16[0],
        setNewTypedString = _useState16[1];

    var typingInterval = 1000 * 60 / (typingSpeed * 5); // ms

    var deleteInterval = 1000 * 60 / (deleteSpeed * 5); // ms

    var nextItem;
    var elapsed = 0;

    var getNextItem = function getNextItem(items) {
      var item;

      if (itemIndex >= items.length) {
        return {
          direction: END // animation ends

        };
      }

      item = items[itemIndex];

      if (typeof item === 'string') {
        return {
          direction: FORWARD,
          string: item
        };
      }

      switch (item.type.displayName) {
        case 'LineBreak':
          return {
            direction: LINEBREAK
          };

        case 'Delete':
          var delay = false;
          var newDeleteChar = 0;

          if (deleteChar === 0) {
            if (item.props.characters === 0) {
              newDeleteChar = newTypedString.length;
            } else {
              newDeleteChar = item.props.characters;
            }

            setDeleteChar(newDeleteChar);
            delay = true;
          } else {
            newDeleteChar = deleteChar - 1;
            setDeleteChar(newDeleteChar);
          }

          return {
            delay: delay,
            direction: BACKSPACE,
            chars: newDeleteChar
          };

        case 'Delay':
          return {
            direction: PAUSE,
            ms: item.props.ms
          };

        default:
          throw 'Error: Invalid item passed in `strings` props or as children.';
      }
    };

    var updateTypedString = function updateTypedString(interval, nts) {
      return function () {
        var time = performance.now();

        if (elapsed === 0) {
          elapsed = time;
        }

        if (time >= elapsed + interval) {
          elapsed = time;
          var split = nts.split('•');
          setTypedString(split.map(function (str, index) {
            return React__default.createElement("span", {
              key: "".concat(instanceId, "-").concat(index)
            }, str, split.length - index > 1 ? React__default.createElement("br", null) : null);
          }));
        } else {
          window.setTimeout(updateTypedString(interval, nts), interval);
        }
      };
    };

    React.useEffect(function () {
      if (window && !window._TYPEME) {
        var styleSheet = document.styleSheets[0];

        if (!styleSheet) {
          var style = document.createElement('style');
          document.head.append(style);
          styleSheet = style.sheet;
        }

        var animName = 'tm-blink';
        var animStyle = "{0%{opacity:1;}49%{opacity:1;}50%{opacity:0;}100%{opacity:0;}}";
        var keyframes = ["@keyframes ".concat(animName).concat(animStyle), "@-webkit-keyframes ".concat(animName).concat(animStyle), ".tm-cursor{display:inline-block;transform:scale(1.2);font:inherit;position:relative;font-style:normal !important;}", ".tm-blink{animation:".concat(animName, " ").concat(cursorBlinkSpeed, "ms infinite !important;}")];
        keyframes.forEach(function (style) {
          styleSheet.insertRule(style, styleSheet.cssRules.length);
        });
        window._TYPEME = true;
      }
    }, []);
    React.useEffect(function () {
      if (startAnimation) {
        var items = [];

        if (strings && Array.isArray(strings)) {
          items = strings;
        }

        if (strings && typeof strings === 'string') {
          items = [strings];
        }

        if (children && typeof children === 'string') {
          items = [children];
        }

        if (children && Array.isArray(children)) {
          items = children;
        }

        nextItem = getNextItem(items);
        var _nextItem = nextItem,
            direction = _nextItem.direction;

        if (direction === END) {
          onAnimationEnd();

          if (loop) {
            setCharIndex(0);
            setItemIndex(0);
            setTypedString('');
            setNewTypedString('');
          } else {
            setAnimationEnded(true);
          }
        } else {
          if (direction === FORWARD) {
            // type next character
            var nts = "".concat(newTypedString).concat(nextItem.string[charIndex]);
            setNewTypedString(nts);
            window.setTimeout(updateTypedString(typingInterval, nts), typingInterval);

            if (charIndex >= nextItem.string.length - 1) {
              setCharIndex(0);
              setItemIndex(function (prevIndex) {
                return prevIndex + 1;
              });
            } else {
              setCharIndex(function (prevIndex) {
                return prevIndex + 1;
              });
            }
          } else if (direction === LINEBREAK) {
            // break line
            var _nts = "".concat(newTypedString, "\u2022");

            setNewTypedString(_nts);
            window.setTimeout(updateTypedString(typingInterval, _nts), typingInterval);
            setItemIndex(function (prevIndex) {
              return prevIndex + 1;
            });
            setCharIndex(0);
          } else if (direction === BACKSPACE) {
            // delete previous character
            var _nts2 = "".concat(newTypedString.substring(0, newTypedString.length - 1));

            setNewTypedString(_nts2);

            if (nextItem.chars === 1) {
              setItemIndex(function (prevIndex) {
                return prevIndex + 1;
              });
              setCharIndex(0);
              setDeleteChar(0);
            }

            if (nextItem.delay) {
              window.setTimeout(function () {
                window.setTimeout(updateTypedString(deleteInterval, _nts2), deleteInterval);
              }, backspaceDelay);
            } else {
              window.setTimeout(updateTypedString(deleteInterval, _nts2), deleteInterval);
            }
          } else if (direction === PAUSE) {
            // pause animation
            setItemIndex(function (prevIndex) {
              return prevIndex + 1;
            });
            setCharIndex(0);
            window.setTimeout(function () {
              setAnimationPaused(false);
              window.setTimeout(updateTypedString(typingInterval, newTypedString), typingInterval);
            }, nextItem.ms);
            setAnimationPaused(true);
          }
        }
      }
    }, [startAnimation, typedString]);
    var containerCn = 'tm';
    var cursorCn = 'tm-cursor';

    if (className) {
      containerCn = "".concat(containerCn, " ").concat(className);
    }

    if (!startAnimation || animationEnded || animationPaused) {
      cursorCn = "".concat(cursorCn, " tm-blink");
    }

    return React__default.createElement("span", {
      className: containerCn
    }, typedString, React__default.createElement("span", {
      key: "".concat(instanceId, "-cur"),
      className: cursorCn
    }, animationEnded && hideCursor ? '' : cursorCharacter));
  };

  TypeMe.defaultProps = {
    onAnimationEnd: function onAnimationEnd() {},
    startAnimation: true,
    cursorCharacter: '|',
    cursorBlinkSpeed: 800,
    // ms
    backspaceDelay: 500,
    // ms
    typingSpeed: 500,
    // WPM
    deleteSpeed: 800,
    // WPM
    hideCursor: false,
    className: '',
    loop: false,
    strings: []
  };

  var Delete = function Delete() {
    return null;
  };

  Delete.displayName = 'Delete';
  Delete.defaultProps = {
    characters: 0
  };

  var LineBreak = function LineBreak() {
    return null;
  };

  LineBreak.displayName = 'LineBreak';

  var Delay = function Delay() {
    return null;
  };

  Delay.displayName = 'Delay';
  Delay.defaultProps = {
    ms: 0
  };

  exports.Delay = Delay;
  exports.Delete = Delete;
  exports.LineBreak = LineBreak;
  exports.default = TypeMe;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
